import { Routes } from '@angular/router';
import { LoginComponent } from './modules/Login/login/login.component';
import { content } from './shared/routes';
import { MainLayoutComponent } from './modules/layout/main-layout/main-layout.component';
import { authGuard } from './infrastructure/guards/auth.guard';

export const routes: Routes = [
     {
        path: "login", component: LoginComponent
    },
     {
        path: '', redirectTo: "/admin/dashboard", pathMatch: "full"

    },
    {
        path: 'admin',
        children: content,
        component: MainLayoutComponent,
          canActivate: [authGuard]
        
    },
    {
        path: '**', redirectTo: "/admin/dashboard", pathMatch: "full"

    },
];
